module.exports = __webpack_public_path__ + "static/media/tsf_logo.b40255e4.png";